import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { ShipmentStatus } from '@web/shared/module/shop';

@jsonObject
export class AdminOrderShipmentTrackingResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly status!: ShipmentStatus;

  @jsonMember(String)
  public readonly trackingUrl?: Nillable<string>;

  @jsonMember(Date)
  public readonly scheduledShippingDate?: Nillable<Date>;
}
